import xor from 'lodash.xor';

export const hToggleArrayItem = (array, item) => xor(array, [item]);
